// src/components/analytics/SimpleWordCloud.tsx
import React from 'react';

interface WordCloudProps {
  words: Array<{
    text: string;
    value: number;
  }>;
  maxFontSize?: number;
  minFontSize?: number;
}

const SimpleWordCloud: React.FC<WordCloudProps> = ({ 
  words, 
  maxFontSize = 48, 
  minFontSize = 14 
}) => {
  if (!words || words.length === 0) return null;
  
  // Find the max and min values to scale fonts
  const maxValue = Math.max(...words.map(w => w.value));
  const minValue = Math.min(...words.map(w => w.value));
  
  // Generate a color based on word value
  const getColor = (value: number) => {
    const colors = ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd'];
    const index = Math.min(
      Math.floor(((value - minValue) / (maxValue - minValue)) * colors.length),
      colors.length - 1
    );
    return colors[index];
  };
  
  // Calculate font size based on value
  const getFontSize = (value: number) => {
    if (maxValue === minValue) return (maxFontSize + minFontSize) / 2;
    const size = minFontSize + ((value - minValue) / (maxValue - minValue)) * (maxFontSize - minFontSize);
    return Math.max(minFontSize, Math.min(maxFontSize, size));
  };
  
  return (
    <div className="simple-word-cloud" style={{ textAlign: 'center', padding: '20px' }}>
      {words.map((word, index) => (
        <span
          key={index}
          style={{
            fontSize: `${getFontSize(word.value)}px`,
            color: getColor(word.value),
            margin: '5px 10px',
            display: 'inline-block',
            fontWeight: word.value > (maxValue + minValue) / 2 ? 'bold' : 'normal'
          }}
        >
          {word.text}
        </span>
      ))}
    </div>
  );
};

export default SimpleWordCloud;